var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shape",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8214887,9.16666667 L9.41074435,4.75592232 C9.08530744,4.43048541 9.08530744,3.90284793 9.41074435,3.57741102 C9.73618126,3.25197411 10.2638187,3.25197411 10.5892557,3.57741102 L16.422589,9.41074435 C16.7480259,9.73618126 16.7480259,10.2638187 16.422589,10.5892557 L10.5892557,16.422589 C10.2638187,16.7480259 9.73618126,16.7480259 9.41074435,16.422589 C9.08530744,16.0971521 9.08530744,15.5695146 9.41074435,15.2440777 L13.8214887,10.8333333 L4.16666667,10.8333333 C3.70642938,10.8333333 3.33333333,10.4602373 3.33333333,10 C3.33333333,9.53976271 3.70642938,9.16666667 4.16666667,9.16666667 L13.8214887,9.16666667 Z",
    id: "Combined-Shape",
    fill: "#777776",
    fillRule: "nonzero"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_right.c20d1e5a.svg";
export { ForwardRef as ReactComponent };